import {
  Box, Checkbox, FormControlLabel, Grid, IconButton, TextField, Tooltip, Typography,
  Accordion, AccordionSummary, AccordionDetails
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { COMMON_STYLE } from '../../../../Utility/Constants';
import ShowComponents from '../../DoctorNotes/Common/ShowComponent';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


const posteriorState = {
  appointmentId: '',
  patientId: '',
  doctorId: '',
  clinicId: '',
  right_eye_check: false,
  left_eye_check: false,
  normal_check: false,

  le_disc: '',
  le_macula: '',
  le_media: '',
  le_vessels: '',
  le_periphery: '',
  le_anterior_image_key: '',
  le_image_json: '',
  re_disc: '',
  re_macula: '',
  re_media: '',
  re_vessels: '',
  re_periphery: '',
  posteriorComments: '',

  prev_le_disc: '',
  prev_le_macula: '',
  prev_le_media: '',
  prev_le_vessels: '',
  prev_le_periphery: '',
  prev_le_anterior_image_key: '',
  prev_le_image_json: '',
  prev_re_disc: '',
  prev_re_macula: '',
  prev_re_media: '',
  prev_re_vessels: '',
  prev_re_periphery: '',
  prev_posteriorComments: '',

  posteriorList: {},
  enableCopy: false,
  right_eye_data: '',
  left_eye_data: '',
  dupPosteriorComments: ''
}

const UmaPosteriorSegment = React.forwardRef((props, ref) => {
  const [posterior, setPosterior] = useState(posteriorState)
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })

  React.useImperativeHandle(ref, () => ({
    performPosteriorSegmentAction: () => {
      let leftEye = posterior.left_eye_data === '' ? '' : JSON.parse(posterior.left_eye_data)
      let rightEye = posterior.right_eye_data === '' ? '' : JSON.parse(posterior.right_eye_data)
      const leftEyeKeys = ["disc", "macula", "media", "vessels", "periphery"];
      const rightEyeKeys = ["disc", "macula", "media", "vessels", "periphery"];
      const hasChanges = leftEyeKeys.some(key => leftEye[key] !== posterior[`le_${key}`]) ||
        rightEyeKeys.some(key => rightEye[key] !== posterior[`re_${key}`]) ||
        posterior.dupPosteriorComments !== JSON.stringify(posterior.posteriorComments);

      if (hasChanges) {
        postPosteriorSegmentData()
      }
    }
  }))

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: `${message} - POSTERIOR SEGMENT`,
    })
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: `${message} - POSTERIOR SEGMENT`,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  const apicalls = async () => {
    await getPosterSegmentData()
    await getPrevPosteriorSegmentData()
    // await getPosteriorSuggData()
  }

  useEffect(() => {
    if (posterior.posteriorList) {
      let copy = Object.keys(posterior.posteriorList)?.length > 0 ? true : false
      setPosterior((prev) => ({
        ...prev,
        enableCopy: copy
      }))
    }
  }, [posterior.posteriorList])

  useEffect(() => {
    const eyeKeys = ["disc", "macula", "media", "vessels", "periphery"];

    const hasChanges =
      eyeKeys.some(key => String(posterior?.[`le_${key}`] || '').trim() !== '') ||
      eyeKeys.some(key => String(posterior?.[`re_${key}`] || '').trim() !== '') ||
      (String(posterior?.posteriorComments || '').trim() !== '');

    props.setAccordionOpen(hasChanges);
  }, [posterior]);

  const getPosterSegmentData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_POSTERIOR_SEGMENT + '?appointment_id=' + props?.props?.appointment_id + '&doctor_id=' + props?.props?.doctorID)
      if (response?.data?.status === 'success') {
        let postData = Object?.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
        setPosterior((prev) => ({
          ...prev,
          le_disc: Object?.keys(postData)?.length > 0 ? postData?.left_eye?.disc : '',
          le_macula: Object?.keys(postData)?.length > 0 ? postData?.left_eye?.macula : '',
          le_media: Object?.keys(postData)?.length > 0 ? postData?.left_eye?.media : '',
          le_vessels: Object?.keys(postData)?.length > 0 ? postData?.left_eye?.vessels : '',
          le_periphery: Object?.keys(postData)?.length > 0 ? postData?.left_eye?.periphery : '',
          left_eye_data: Object?.keys(postData)?.length > 0 ? JSON.stringify(postData?.left_eye) : '',

          re_disc: Object?.keys(postData)?.length > 0 ? postData?.right_eye?.disc : '',
          re_macula: Object?.keys(postData)?.length > 0 ? postData?.right_eye?.macula : '',
          re_media: Object?.keys(postData)?.length > 0 ? postData?.right_eye?.media : '',
          re_vessels: Object?.keys(postData)?.length > 0 ? postData?.right_eye?.vessels : '',
          re_periphery: Object?.keys(postData)?.length > 0 ? postData?.right_eye?.periphery : '',
          right_eye_data: Object.keys(postData)?.length > 0 ? JSON.stringify(postData?.right_eye) : '',

          posteriorComments: Object?.keys(postData)?.length > 0 ? postData?.comments : '',
          dupPosteriorComments: Object?.keys(postData)?.length > 0 ? JSON.stringify(postData?.comments) : JSON.stringify(''),
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const getPrevPosteriorSegmentData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_POSTERIOR_SEGMENT_COPY +
        '?appointment_id=' + props?.props?.appointment_id + '&patient_id=' + props?.props?.patient_id + '&doctor_id=' + props?.props?.doctorID
      )
      if (response?.data?.status === 'success') {
        let postData = Object?.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
        setPosterior((prev) => ({
          ...prev,
          prev_le_disc: Object?.keys(postData)?.length > 0 ? postData?.left_eye?.disc : '',
          prev_le_macula: Object?.keys(postData)?.length > 0 ? postData?.left_eye?.macula : '',
          prev_le_media: Object?.keys(postData)?.length > 0 ? postData?.left_eye?.media : '',
          prev_le_vessels: Object?.keys(postData)?.length > 0 ? postData?.left_eye?.vessels : '',
          prev_le_periphery: Object?.keys(postData)?.length > 0 ? postData?.left_eye?.periphery : '',

          prev_re_disc: Object?.keys(postData)?.length > 0 ? postData?.right_eye?.disc : '',
          prev_re_macula: Object?.keys(postData)?.length > 0 ? postData?.right_eye?.macula : '',
          prev_re_media: Object?.keys(postData)?.length > 0 ? postData?.right_eye?.media : '',
          prev_re_vessels: Object?.keys(postData)?.length > 0 ? postData?.right_eye?.vessels : '',
          prev_re_periphery: Object?.keys(postData)?.length > 0 ? postData?.right_eye?.periphery : '',
          prev_posteriorComments: Object?.keys(postData)?.length > 0 ? postData?.comments : '',

          posteriorList: Object.keys(postData)?.length > 0 ? postData : {}
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const getPosteriorSuggData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_POSTERIOR_SEGMENT_SUGG  + '?doctor_id=' + props?.props?.doctorID)

      if (response?.data?.status === 'success') {
        console.log('Sugg')
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const postPosteriorSegmentData = async () => {
    try {
      let data = {
        appointment_id: props?.props?.appointment_id,
        comments: posterior.posteriorComments,
        right_eye: {
          eye_type: 'RE',
          disc: posterior.re_disc,
          retina: '',
          macula: posterior.re_macula,
          fundus: '',
          media: posterior.re_media,
          vessels: posterior.re_vessels,
          periphery: posterior.re_periphery
        },
        left_eye: {
          eye_type: 'LE',
          disc: posterior.le_disc,
          retina: '',
          macula: posterior.le_macula,
          fundus: '',
          media: posterior.le_media,
          vessels: posterior.le_vessels,
          periphery: posterior.le_periphery
        }
      }
      const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_POSTERIOR_SEGMENT)
      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        await getPosterSegmentData()
      }

    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const textbox = (names, values) => {
    try {
      return (
        <TextField
          disabled={props?.props?.patient_transfered || props?.props?.isLocked}
          size='small'
          sx={{ width: '13.5dvw' }}
          value={values}
          onChange={(e) => setPosterior((prev) => ({ ...prev, [names]: e.target.value }))}
          placeholder='Type Remarks'
          InputProps={{ style: { height: COMMON_STYLE.HEIGHT }, emed_tid: names }}
        />
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const onChangeCheckBoxHandler = (e, key) => {
    try {
      let checked = e.target.checked
      const updateEyeState = (eye) => ({
        [`${eye}_disc`]: checked ? "Normal" : '',
        [`${eye}_macula`]: checked ? "Normal" : '',
        [`${eye}_media`]: checked ? "Clear" : '',
        [`${eye}_vessels`]: checked ? "Normal" : '',
        [`${eye}_periphery`]: checked ? "Normal" : '',
      });
      setPosterior((prev) => {
        switch (key) {
          case 'right_eye_check':
            return {
              ...prev,
              right_eye_check: checked,
              normal_check: prev.left_eye_check && checked,
              ...updateEyeState('re')
            };
          case 'left_eye_check':
            return {
              ...prev,
              left_eye_check: checked,
              normal_check: prev.right_eye_check && checked,
              ...updateEyeState('le')
            };
          case 'normal_check':
            return {
              ...prev,
              normal_check: checked,
              left_eye_check: checked,
              right_eye_check: checked,
              ...updateEyeState('le'),
              ...updateEyeState('re')
            };
          default:
            return prev;
        }
      });
    } catch (error) {
      errorMessage(error.message)
    }
  }

  return (
    <ShowComponents onIntersection={apicalls}>
      <Box component={'div'}>
        <Accordion expanded={props.accordionOpen}
          onChange={(_, isExpanded) => {
            props.setAccordionOpen(isExpanded, true);
          }}>
          <AccordionSummary className='doc_notes_header_card' expandIcon={<ExpandMoreIcon />}>
          <Box component={'div'} className='doc_notes_header_card' display={'flex'} justifyContent={'space-between'} alignItems={'center'} width = {"100%"}>
            <Box component={'div'} display={'flex'} alignItems={'center'}>
              <Typography className='doc_notes_header_card_font'>Posterior Segment</Typography>
              <Tooltip placement='top' arrow title={'Copy'}><IconButton className='Common_Btn_Min_Width' emed_tid='pst_cpy'
                disabled={!posterior.enableCopy || props?.props?.patient_transfered || props?.props?.isLocked}
                onClick={() => {setPosterior((prev) => ({
                  ...prev,
                  le_disc: posterior.prev_le_disc,
                  le_macula: posterior.prev_le_macula,
                  le_media: posterior.prev_le_media,
                  le_vessels: posterior.prev_le_vessels,
                  le_periphery: posterior.prev_le_periphery,
                  re_disc: posterior.prev_re_disc,
                  re_macula: posterior.prev_re_macula,
                  re_media: posterior.prev_re_media,
                  re_vessels: posterior.prev_re_vessels,
                  re_periphery: posterior.prev_re_periphery,
                  posteriorComments: posterior.prev_posteriorComments
                }))
              }}
              ><ContentCopyIcon color={!posterior.enableCopy ? '' : 'primary'} /></IconButton></Tooltip>
            </Box>
            <Box component={'div'}>
              <FormControlLabel control={<Checkbox size='small' disabled={props?.props?.patient_transfered || props?.props?.isLocked} checked={posterior.right_eye_check} onChange={(e) => onChangeCheckBoxHandler(e, 'right_eye_check')} />} label="Right Eye" />
              <FormControlLabel control={<Checkbox size='small' disabled={props?.props?.patient_transfered || props?.props?.isLocked} checked={posterior.left_eye_check} onChange={(e) => onChangeCheckBoxHandler(e, 'left_eye_check')} />} label="Left Eye" />
              <FormControlLabel control={<Checkbox size='small' disabled={props?.props?.patient_transfered || props?.props?.isLocked} checked={posterior.normal_check} onChange={(e) => onChangeCheckBoxHandler(e, 'normal_check')} />} label="Normal" />
            </Box>
          </Box>
          </AccordionSummary>
          <AccordionDetails component={'div'} m={'0.5rem'}>
            <Box component={'div'}>
              <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'></Typography></Grid>
                <Grid xs={4.5}><Typography className='doc_notes_header_card_font'>Right Eye</Typography></Grid>
                <Grid xs={4.5}><Typography className='doc_notes_header_card_font'>Left Eye</Typography></Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'>Disc</Typography></Grid>
                <Grid xs={4.5}>{textbox('re_disc', posterior.re_disc)}</Grid>
                <Grid xs={4.5}>{textbox('le_disc', posterior.le_disc)} </Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'>Macula</Typography></Grid>
                <Grid xs={4.5}>{textbox('re_macula', posterior.re_macula)}</Grid>
                <Grid xs={4.5}>{textbox('le_macula', posterior.le_macula)} </Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'>Media</Typography></Grid>
                <Grid xs={4.5}>{textbox('re_media', posterior.re_media)}</Grid>
                <Grid xs={4.5}>{textbox('le_media', posterior.le_media)} </Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'>Vessels</Typography></Grid>
                <Grid xs={4.5}>{textbox('re_vessels', posterior.re_vessels)}</Grid>
                <Grid xs={4.5}>{textbox('le_vessels', posterior.le_vessels)} </Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'>Periphery</Typography></Grid>
                <Grid xs={4.5}>{textbox('re_periphery', posterior.re_periphery)}</Grid>
                <Grid xs={4.5}>{textbox('le_periphery', posterior.le_periphery)} </Grid>
              </Grid>
            </Box>
            <Box component={'div'} mt={'0.5rem'}>
              <TextField
                disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                size='small'
                multiline
                fullWidth
                maxRows={5}
                value={posterior.posteriorComments}
                onChange={(e) => {
                  let value = e.target.value
                  if (value?.length <= COMMON_STYLE.CHAR_LIMIT_DESP || value === '') {
                    setPosterior({ ...posterior, posteriorComments: value })
                  }
                }}
                placeholder='Comments'
                InputProps={{ emed_tid: 'pst_cmts' }}
              />
            </Box>
          </AccordionDetails>
        </Accordion>
        {message.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={message.isErrorMsgText}
            msgPop={msgClose}
          />
          : null}
        {message.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={message.successMsgText}
            msgPop={msgClose}
          />
          : null}
      </Box>
    </ShowComponents>
  )
})

export default UmaPosteriorSegment